module.exports = __webpack_public_path__ + "static/media/mlh-partner.1ea774d9.svg";